var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"sticky-tools"},[_vm._t("columns")],2)}
var staticRenderFns = []

export { render, staticRenderFns }